// extracted by mini-css-extract-plugin
export default {"document":"CarouselNode_document__+ynwu","text":"CarouselNode_text__Pmt10","placeholder":"CarouselNode_placeholder__J9cOJ","cards-container":"CarouselNode_cards-container__hOuni"};